export const getModelFromURL = (url, model, $config, exceptions) => {
    let options = {}
    if (url.startsWith('/iframe')) url = url.replace('/iframe', '')
    if (url.length > 1) url = url.replace(/\/$/, '')
    const url_to_models = $config.public?.builderConfig?.mappings || []
    for (const item in url_to_models) {
        const pattern = item
        const regex = new RegExp(pattern)
        if (regex.test(url)) {
            model = (typeof url_to_models[pattern] === 'string') ? url_to_models[pattern] : url_to_models[pattern].model
            if (url_to_models[pattern].options) options = url_to_models[pattern].options
            if (url_to_models[pattern].rewrite) url = url.replace(regex, url_to_models[pattern].rewrite)
            break;
        }
    }
    
    if (exceptions && exceptions.hasOwnProperty(url)) { model = exceptions[url] }
    
    return { model, options, url }
}